import { Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Log } from 'src/app/core/console.log';
import { DropdownModel } from 'src/app/models/master/dropdown-model';
import { MasterService } from 'src/app/services/master.service';
import { inputMgsErrs } from 'src/app/validators/message-validation';
import { DropdownFormControl } from '../dropdown-form-control';

@Component({
  selector: 'app-input-dp-relationship',
  templateUrl: './input-dp-relationship.component.html',
  styleUrls: ['./input-dp-relationship.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDpRelationshipComponent),
      multi: true
    }
  ]
})
export class InputDpRelationshipComponent extends DropdownFormControl implements OnInit {
  @Input() label: any;
  @Input() isDisabled: boolean;
  errors = inputMgsErrs.relationship;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer,
    private translate: TranslateService,
    private masterService: MasterService
  ) {
    super(cc);
  }

  ngOnInit() {
    this.checkInitialControl();
    this.initDropdownList();
  }

  initDropdownList() {
    this.resetDropdownList();
    this.masterService.getRelation().subscribe(result => {
      this.items.push(...result);
      this.findValueFromList(this.value);
    }, error => {
      Log.error(error);
    });

  }

  resetDropdownList(val?: any) {
    this.items = new Array<DropdownModel>();
    this.translate.get('input.dropdown.select.relationship').subscribe(label => {
      this.items.push({ value: null, label: label, data: null });
    });
  }


}
